// src/internal/components/referral-program-panel/with-referral-render.tsx
import React from "react";
import { useAuthContext } from "@clara/auth";
import { useLocaleContext } from "@clara/locale";
import {
  get,
  isEmpty,
  isUndefined,
  runIfFn,
  isNull,
  objectFilter
} from "@clara/utils";
import { jsx } from "react/jsx-runtime";
function WithReferralRender(props) {
  const { children: childrenProp, ...program } = props;
  const { user: current } = useAuthContext();
  const { lang } = useLocaleContext();
  if (isNull(current) || isUndefined(program))
    return null;
  const user = getUserReferralProps({ ...current, locale: lang });
  const campaigns = objectFilter(program == null ? void 0 : program.widgetTypes, (val) => !isEmpty(val));
  const _widgetType = getWidgetType(current);
  const widgetType = get(campaigns, _widgetType);
  const children = runIfFn(childrenProp, {
    user,
    config: {
      tenantAlias: program.tenantAlias
    },
    widgetType,
    tokenUrl: program.jwtUrl
  });
  return /* @__PURE__ */ jsx(React.Fragment, { children });
}
function getWidgetType({ email, role }) {
  return (email == null ? void 0 : email.includes("clara.team")) ? "clara" : role === "COMPANYOWNER" ? "owner" : "general";
}
function getUserReferralProps(user) {
  return {
    id: user.uuid,
    accountId: user.companyUuid,
    email: user.email,
    firstName: user.firstName,
    lastname: user.paternalsurname || user.maternalsurname,
    locale: user.locale.replace(/-/g, "_")
  };
}

export {
  WithReferralRender
};
